module.exports = __webpack_public_path__ + "img/selected7-min.be3b17bb.png";